import { useCallback } from 'react';
import { useGetApiUserInfoQuery, useGetProjectQuery } from '../store/userOrg/enhancedUserOrgApi';
import { platformAdminRoleName } from 'constants/permissions';

export default function useCheckPermission() {
    const { data: me } = useGetApiUserInfoQuery();

    const mySystemRole = me?.SystemRoles?.find(systemRole => systemRole.ProjectShortName === '')?.RoleName;

    const isPlatformAdmin = mySystemRole === platformAdminRoleName;

    const { data: projects } = useGetProjectQuery({}, { skip: isPlatformAdmin });

    return useCallback(
        (permissionOrRole: string, project: string | null | undefined) => {
            if (isPlatformAdmin) {
                return true;
            }

            if (!me) return false;

            if (project === '') {
                const systemRole = me.SystemRoles?.find(role => role.ProjectShortName === '');
                return (
                    systemRole?.SystemPermissionTypes?.includes(permissionOrRole) ||
                    systemRole?.RoleName === permissionOrRole
                );
            }

            if (projects) {
                const projectData = projects.find(
                    p => p.Name === project || p.ShortName === project || p.Id === project
                );

                const userRoleForProject = me.SystemRoles?.find(
                    item => item.ProjectShortName === projectData?.ShortName
                );

                return (
                    userRoleForProject?.SystemPermissionTypes?.includes(permissionOrRole) ||
                    userRoleForProject?.RoleName === permissionOrRole
                );
            }

            return false;
        },
        [me, projects, mySystemRole]
    );
}
